import { WORDPRESS_API } from "shared/constants/api";


export const parentDocumentGroups = [
  {
    id: "school",
    title: "Dokumenty szkolne",
    documents: [
      {
        id: "program-wychowawczo-profilaktyczny",
        title: "Program Wychowawczo-Profilaktyczny",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/SC227-CKZIU23120611281.pdf`
      },
      {
        id: "uchwala-rady-pedagogicznej",
        title: "Uchwała nr 8/2023/2024",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Uchwala-Rady-Pedagogicznej.pdf`
      },
      {
        id: "kazdy-inny-wszyscy-rowni",
        title: "Projekt „Każdy Inny – Wszyscy Równi”",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/SC227-CKZIU23120611270.pdf`
      }
    ]
  },
  {
    id: "student",
    title: "Sprawy ucznia",
    documents: [
      {
        id: "duplikat-swiadectwa-legitymacji",
        title: "Duplikat świadectwa i legitymacji szkolnej",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Duplikat-świadectwa-i-legitymacji-szkolnej.pdf`
      },
      {
        id: "kontrola-obowiazku-nauki",
        title: "Kontrola realizacji obowiązku nauki",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Kontrola-realizacji-obowiązku-nauki.pdf`
      },
      {
        id: "usprawiedliwianie-nieobecnosci",
        title: "Procedura usprawiedliwiania nieobecności",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Procedura-usprawiedliwiania-nieobecności.pdf`
      },
      {
        id: "nagrody-uczniow",
        title: "Regulamin przyznawania nagród uczniom",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Regulamin-przyznawania-nagród-uczniom.pdf`
      },
      {
        id: "szafki-szkolne",
        title: "Regulamin użytkowania szafek szkolnych",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Regulamin-użytkowania-szafek-szkolnych.pdf`
      },
      {
        id: "rozklad-lekcji",
        title: "Rozkład lekcji i przerw międzylekcyjnych",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Rozkład-lekcji-i-przerw-międzylekcyjnych.pdf`
      },
      {
        id: "skreslenie-z-listy",
        title: "Skreślenie z listy uczniów",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Skreślenie-z-listy-uczniów.pdf`
      },
      {
        id: "zwolnienie-wf",
        title: "Wniosek o zwolnienie z w-f",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Wniosek-o-zwolnienie-z-w-f.pdf`
      },
      {
        id: "opuszczanie-terenu-szkoly",
        title: "Zasady opuszczania przez uczniów terenu szkoły",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Zasady-opuszczania-przez-uczniów-terenu-szkoły.pdf`
      }
    ]
  },
  {
    id: "support",
    title: "Pomoc i procedury",
    documents: [
      {
        id: "pomoc-psychologiczno-pedagogiczna",
        title: "Pomoc psychologiczno-pedagogiczna",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Pomoc-psychologiczno-pedagogiczna.pdf`
      },
      {
        id: "skargi-i-wnioski",
        title: "Rozpatrywanie skarg i wniosków",
        href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Rozpatrywanie-skarg-i-wniosków.pdf`
      }
    ]
  }
];


export const parentJournal = {
  url: "https://uonetplus.vulcan.net.pl/powiatpilski",
  instructionUrl: `${WORDPRESS_API}/wp-content/uploads/2020/03/uonetplus_Pierwsze-logowanie.pdf`
};

export { insuranceDocuments as parentInsuranceDocuments }
  from "../../insurance/data/insuranceDocuments";